import React, {useCallback, useState} from 'react';

import {useAlertCriteria} from 'src/modules/profile/user/tabs/content/alerts/hooks/useAlertCriteria';
import {SCOPE_KEY} from 'src/modules/profile/user/tabs/content/alerts/util';
import {AlertPageRequest} from 'src/openapi/admin/models/AlertPageRequest';
import {AlertSortField} from 'src/openapi/admin/models/AlertSortField';
import {SearchListType} from 'src/openapi/admin/models/SearchListType';

import ComboBox, {ComboboxItem} from '@pb/kit-component-combo-box';
import {SortHeaderFilter} from '@pb/kit-component-filters';
import Label from '@pb/kit-component-label';
import {Cell} from '@pb/kit-component-table';

import {apiToUiSort, uiToApiSort} from '../../utils/util';

type Props = {
    getItemDescription: (code: string) => string,
};

export const AlertListTypeHeader: React.FC<Props> = ({getItemDescription}) => {
    const initialState = React.useMemo(() => ({searchListType: undefined}), []);
    const [request, setRequest] = useState<Partial<AlertPageRequest>>(initialState);
    const {criteria, setSort, setCriteria} = useAlertCriteria(SCOPE_KEY);
    const direction =
        criteria?.alertSortField === AlertSortField.SEARCH_LIST_TYPE
            ? apiToUiSort(criteria.sortDirection)
            : undefined;

    const onCancel = useCallback(() => (
        setRequest(criteria?.searchListType
            ? {searchListType: criteria.searchListType}
            : initialState)
    ), [criteria?.searchListType, setRequest, initialState]);

    return (
        <Cell className="text-align_center">
            <SortHeaderFilter
                caption="Search / List Type"
                filterActive={!!criteria?.searchListType}
                sortable={true}
                direction={direction}
                defaultDirection="ASC"
                onSort={dir => setSort(AlertSortField.SEARCH_LIST_TYPE, uiToApiSort(dir))}
                onReset={() => {
                    setRequest({searchListType: undefined});
                    setCriteria({searchListType: undefined});
                }}
                onCancel={onCancel}
                onApply={() => {
                    setCriteria(request);
                }}>
                <div>
                    <Label>Search / List Type</Label>
                    <ComboBox<SearchListType, SearchListType>
                        value={criteria?.searchListType ? criteria.searchListType : request.searchListType ?? undefined}
                        onChange={val => setRequest({searchListType: val})}
                        placeholder="Select Search / List Type">
                        {Object.values(SearchListType).map(code => (
                            <ComboboxItem
                                key={code}
                                caption={getItemDescription(code)}
                                value={code}
                            />
                        ))}
                    </ComboBox>
                </div>
            </SortHeaderFilter>
        </Cell>
    );
};
